var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExpandArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40987 9H17.5899C17.7876 9.00083 17.9807 9.06028 18.1447 9.17085C18.3087 9.28141 18.4362 9.43811 18.5111 9.62115C18.5861 9.80418 18.605 10.0053 18.5656 10.1991C18.5263 10.3929 18.4303 10.5707 18.2899 10.71L12.7099 16.29C12.6169 16.3837 12.5063 16.4581 12.3844 16.5089C12.2626 16.5596 12.1319 16.5858 11.9999 16.5858C11.8679 16.5858 11.7372 16.5596 11.6153 16.5089C11.4934 16.4581 11.3828 16.3837 11.2899 16.29L5.70987 10.71C5.56945 10.5707 5.47348 10.3929 5.43409 10.1991C5.39471 10.0053 5.41368 9.80418 5.4886 9.62115C5.56353 9.43811 5.69104 9.28141 5.85503 9.17085C6.01901 9.06028 6.2121 9.00083 6.40987 9Z",
    fill: "#6466E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpandArrow);
export default __webpack_public_path__ + "static/media/icon_expand_arrow.6441f780.svg";
export { ForwardRef as ReactComponent };